import { render, staticRenderFns } from "./Scientists.vue?vue&type=template&id=6e74fa85&"
import script from "./Scientists.vue?vue&type=script&lang=ts&"
export * from "./Scientists.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports